import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetInfo,
  Approve,
  Deny,
} from "../../api/apiStore/Authorization/Authorization";
import ConfirmModal from "../../components/ConfirmModal";
import AuthorizeConfirmModal from "../../components/AuthorizeConfirmModal";
import Loading from "../../components/Loading/Loading.jsx";

export default function Authorize() {
  let navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAuthorizeVisible, setIsAuthorizeVisible] = useState(false);
  const [confirmModalMsg, setConfirmModalMsg] = useState("");
  const [clientData, setClientData] = useState({ name: null, id: null });
  const [isLoading, setIsLoading] = useState(false);
  const fetchInfoData = async () => {
    setIsLoading(true);
    const resp = await GetInfo();
    setIsLoading(false);
    if (resp) {
      if (resp.rcrm) {
        setIsModalVisible(true);
        setConfirmModalMsg(`${resp.rcrm.RM}`);
      } else {
        if (resp.memberAccessToken) {
          sessionStorage.setItem("member_access_token", resp.memberAccessToken);
        }
        sessionStorage.setItem("auth_token", resp.authToken);
        setClientData({
          ...clientData,
          name: resp.client.name,
          id: resp.client.id,
        });
      }
    }
  };
  const fetchApprove = async () => {
    setIsLoading(true);
    const resp = await Approve(clientData.name, clientData.id);
    setIsLoading(false);
    if (resp.rcrm.RC === "C01") {
      window.location.replace(`${resp.results.location}`);
    } else {
      setIsModalVisible(true);
      setConfirmModalMsg(`${resp.rcrm.RM}`);
    }
  };

  const fetchDeny = async () => {
    setIsLoading(true);
    const resp = await Deny(clientData.name, clientData.id);
    setIsLoading(false);
    if (resp.rcrm.RC === "C01") {
      window.location.replace(`${resp.results.location}`);
    } else {
      setIsModalVisible(true);
      setConfirmModalMsg(`${resp.rcrm.RM}`);
    }
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleAuthorizeModalOk = () => {
    setIsAuthorizeVisible(false);
    fetchApprove();
  };
  const handleAuthorizeModalCancel = () => {
    setIsAuthorizeVisible(false);
    fetchDeny();
  };

  useEffect(() => {
    setIsAuthorizeVisible(true);
    fetchInfoData();
  }, []);

  return (
    <div>
      <Loading isLoadingVisible={isLoading}></Loading>
      {isModalVisible ? (
        <ConfirmModal
          title="提示"
          setModalvisible={isModalVisible}
          setHandleOk={handleOk}
          msg={confirmModalMsg}
        />
      ) : null}
      {isAuthorizeVisible ? (
        <AuthorizeConfirmModal
          setModalvisible={isAuthorizeVisible}
          handleAuthorizeModalOk={handleAuthorizeModalOk}
          handleAuthorizeModalCancel={handleAuthorizeModalCancel}
          isTextModal={false}
        />
      ) : null}
    </div>
  );
}
